<script setup>
import { ref } from "vue";
import PageHeader from '@/Components/PageHeader.vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableSingle from "@/Components/TableSingle.vue";
import CardBoxComponentRestricted from '@/Components/CardBoxComponentRestricted.vue';

defineProps({
    canRead: Boolean,
    canWrite: Boolean,
    canDelete: Boolean,
    courses: Array,
    select_coursearea: Array,
    select_level: Array,
    param: Object
});
const rutaprefijo = ref('course');
const modulo = ref('Curso');
</script>

<template>
    <Head title="Cursos" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader title="Cursos" />
        </template>

        <div class="py-8 lg:py-10">

            <div class="mx-auto sm:px-6 lg:px-8 px-4">
                <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">
                    <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                    <div class="w-full overflow-x-auto">
                        <CardBox v-if="canRead" class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable isRef ya está por defecto en modulo Nivel -->
                            <TableSingle :modulo="modulo" :data="courses" :select1="select_coursearea" :select2="select_level" :ruta="rutaprefijo" :param="param" />
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentRestricted />
                        </CardBox>
                    </div>
                </div>
            </div>
        </div>

    </BreezeAuthenticatedLayout>
</template>
